import { dataHooks } from '@wix/data-hooks';

export const articleSidebarDataHooks = dataHooks<{
  toggleModeButton;
  externalLink;
  closeButton;
  backButton;
}>('articleSidebar');
